<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">机器ID：</span>
					<el-input v-model="search_mid" class="b_inp" placeholder="机器ID"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">ICCID：</span>
					<el-input v-model="search_iccid" class="b_inp" placeholder="ICCID"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="iccid"
						label="ICCID"
					>
					</el-table-column>
					<el-table-column
						prop="mid"
						label="机器ID"
					>
					</el-table-column>
					<el-table-column
						prop="validLabel"
						label="是否有效"
					>
					</el-table-column>
					<el-table-column
						prop="createDate"
						label="生产日期"
					>
					</el-table-column>
					<el-table-column
						prop="useTime"
						label="首次使用日期"
					>
					</el-table-column>
					<el-table-column
						prop="meal"
						label="套餐信息"
					>
					</el-table-column>
					<el-table-column
						prop="overDate"
						label="到期时间"
					>
					</el-table-column>
					<el-table-column
						prop="cost"
						label="费用/元"
					>
					</el-table-column>
					<el-table-column
						prop="remark"
						label="备注"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								v-if="authInfo.ucategory == 1"
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->
		
		<!-- 修改弹框 -->
		<update v-model="update_display" :obj="update_data" @onSuccess="updateSuccess"></update>
		<!-- 修改弹框 end -->
	</div>
</template>

<script>
	import Update from './components/update.vue';
	import { mapState } from 'vuex';
	import Api from '../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				
				search_mid: '',
				search_iccid: '',
				search_startDate: '',
				search_endDate: '',
				
				tableData: [],
				currentPage: 1,
				total: 0,
				
				update_display: false,
				update_data: {}
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartDateChange () {
				this.compareSearchDate();
			},
			// 切换查询时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.getData();
			},
			// 点击修改
			handleUpdateClick(obj) {
				this.update_data = {...obj};
				this.update_display = true;
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 点击页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},

			/************************ @Function *******************************/
			// 获取列表数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					machineId: that.search_mid,
					iccid: that.search_iccid,
					startTime: that.search_startDate,
					endTime: that.search_endDate
				};
				Api.findSims(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								iccid: v.iccid,
								mid: v.machineId,
								isValid: v.simFlag,
								validLabel: v.simFlag == 1 ? '有效' : '无效',
								createDate: v.productionDate,
								useTime: v.firstUseTime,
								meal: v.packagesInfo,
								overDate: v.dieDate,
								cost: v.feeInfo,
								remark: v.remark
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate () {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		components: {
			Update
		}
	}
</script>

<style>
</style>
